import type { TimeSeriesResponse } from 'api';
import { UseChartDataParams, UseChartDataReturn } from '../types';
import { useCompanyMetricChart } from './useCompanyMetricChart';

const MOCK_INVESTED_CAPITAL_DATA: TimeSeriesResponse = {
  company_id: 9999,
  current: {
    date: '2024-12-31',
    value: '1500000',
  },
  change_percent: '50',
  history: [
    { date: '2023-12-31', value: '800000' },
    { date: '2024-03-31', value: '1000000' },
    { date: '2024-06-30', value: '1000000' },
    { date: '2024-09-30', value: '1200000' },
    { date: '2024-12-31', value: '1500000' },
  ],
};

export const useInvestedCapital = (params: UseChartDataParams): UseChartDataReturn =>
  useCompanyMetricChart({
    ...params,
    metricName: 'invested-capital',
    label: 'Invested Capital',
    color: '#27ae60',
    emphasisColor: '#229954',
    mockData: MOCK_INVESTED_CAPITAL_DATA,
  });
